import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";
import { BetterAuthError } from "../utils";

export const SSO_PROVIDERS_QUERY_KEY = ["sso", "providers"] as const;

async function fetchSsoProviders() {
  const { data, error } = await authClient.sso.providers();
  if (error) {
    throw new Error(betterAuthErrorText(error, "Could not load SSO providers"));
  }
  return data.providers;
}

export type SsoProviderResponse = Awaited<ReturnType<typeof fetchSsoProviders>>[number];

export const ssoProvidersQueryOptions = () => ({
  queryKey: SSO_PROVIDERS_QUERY_KEY,
  queryFn: fetchSsoProviders,
});

export function useSsoProviders(
  options?: UseQueryOptions<
    SsoProviderResponse[],
    BetterAuthError,
    SsoProviderResponse[],
    typeof SSO_PROVIDERS_QUERY_KEY
  >,
) {
  return useQuery({
    ...ssoProvidersQueryOptions(),
    ...options,
  });
}
